"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configFormikInput = exports.defineErrors = exports.handleInputChange = exports.handleRadioChange = exports.handleCheckboxChange = exports.handleSelectChange = void 0;
const R = __importStar(require("ramda"));
const PATH_WITH_DOTS = R.useWith(R.path, [R.split('.')]);
const getOnChangeValue = (nameOrValue, maybeValue) => {
    if (maybeValue !== undefined)
        return maybeValue;
    if (nameOrValue && nameOrValue.target)
        return nameOrValue.target.value;
    return nameOrValue;
};
const handleSelectChange = (formik) => (name, value, isMulti) => {
    if (isMulti) {
        return formik.setFieldValue(name, value + '');
    }
    formik.setFieldValue(name, value);
};
exports.handleSelectChange = handleSelectChange;
const handleCheckboxChange = (formik) => (e) => {
    const name = R.path(['target', 'name'], e);
    const isChecked = R.path(['target', 'checked'], e);
    formik.setFieldValue(name, isChecked);
};
exports.handleCheckboxChange = handleCheckboxChange;
const handleRadioChange = (formik) => (value, name) => {
    formik.setFieldValue(name, value);
};
exports.handleRadioChange = handleRadioChange;
const handleInputChange = (formik, callback) => (e) => {
    const name = R.path(['target', 'name'], e);
    const value = R.path(['target', 'value'], e);
    formik.setFieldValue(name, value);
    if (callback) {
        callback(name, value);
    }
};
exports.handleInputChange = handleInputChange;
const getFormikErroMsg = (name, formik) => R.has(name)(formik.touched) && R.has(name)(formik.errors) && formik.errors[name];
const getInputError = (name, form) => R.hasPath(['errors', name], form) && R.hasPath(['touched', name], form);
const defineErrors = (name, form) => {
    const obj = R.propOr({}, 'values')(form);
    const value = PATH_WITH_DOTS(name)(obj);
    const isError = getInputError(name, form);
    return {
        textError: isError ? getFormikErroMsg(name, form) : '',
        formError: isError,
        value,
    };
};
exports.defineErrors = defineErrors;
const configFormikInput = (name, formik, { customChange, customBlur } = {}) => {
    const onChangeFormikInput = (nameOrValue, maybeValue) => {
        formik.setFieldValue(name, getOnChangeValue(nameOrValue, maybeValue));
    };
    const fieldValue = formik.values[name];
    return {
        name: name,
        value: Number(fieldValue) || fieldValue,
        onChange: customChange || onChangeFormikInput,
        onBlur: customBlur || formik.handleBlur,
    };
};
exports.configFormikInput = configFormikInput;
//# sourceMappingURL=index.js.map